import filterStyles from '../traffic-info-filter.module.scss';

export interface TrafficInfoLegendItem {
  badge: string;
  label: string;
  className: string;
}

export const TRAFFIC_INFO_LEGEND_ITEMS: TrafficInfoLegendItem[] = [
  { badge: 'U79', label: 'U-/Stadtbahn', className: filterStyles.TrafficInfoFilterItemBlue },
  { badge: '709', label: 'Straßenbahn', className: filterStyles.TrafficInfoFilterItemRed },
  { badge: '730', label: 'Bus', className: filterStyles.TrafficInfoFilterItemYellow },
  { badge: 'SB51', label: 'SchnellBus', className: filterStyles.TrafficInfoFilterItemFastBus },
  { badge: 'M1', label: 'MetroBus', className: filterStyles.TrafficInfoFilterItemMetroBus },
  {
    badge: 'SEV',
    label: 'Schienen\u00ADersatz\u00ADverkehr (SEV)',
    className: filterStyles.TrafficInfoFilterItemReplacementRail,
  },
  { badge: 'NE7', label: 'Nachtlinie', className: filterStyles.TrafficInfoFilterItemNightLine },
];
